export default __webpack_public_path__ + "static/media/S0.fc80f5a6.png";